import { render, staticRenderFns } from "./TestimonialItem.vue?vue&type=template&id=8a4b9e38&"
import script from "./TestimonialItem.vue?vue&type=script&lang=js&"
export * from "./TestimonialItem.vue?vue&type=script&lang=js&"
import style0 from "./TestimonialItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports